let exhibitionArea = () => import(/* webpackChunkName: "exhibitionArea" */ '@/views/_lang/exhibitionArea.vue');
export default [
  { path: '/:lang/exhibitionarea', name: 'exhibitionArea', component: exhibitionArea, meta: { isLogin: false, level: '' } },
];
